import { Suspense, useContext, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { ContentContext } from '@parcel2go/npm-p2g-app';
import { AppSurface } from '~/components/surface/app-surface';
import { RouteAppWrapper } from '~/components/route-app-wrapper';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';

const Cancellations = lazy(() => import('~/apps/self-serve/journey/Cancellations'));

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { track } = useSmartSendAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.SELFSERVE);

  useOnLoad(() => {
    const title = t('CANCELLATIONS_PAGE_TITLE', { defaultValue: 'Cancellations' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.SELFSERVE });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title: title, currentPageRoute: RoutingConstants.Cancellations }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.Cancellations
      }
    });
  });

  return (
    <Tagged tag="screen-cancellations">
      <RouteAppWrapper isXs={isXs}>
        <AppSurface>
          <Suspense>
            <Cancellations />
          </Suspense>
        </AppSurface>
      </RouteAppWrapper>
    </Tagged>
  );
}

Component.displayName = 'Cancellations';
